// brand-page hero + scroll-reveal animations — extracted from
// blocks/brand-page.liquid to save Liquid budget against the 100 KB cap.
(function () {
  var h = document.querySelector('[data-pbrand-hero]');
  if (h) {
    [['[data-hero-lockup]', 200], ['[data-hero-tagline]', 450], ['[data-hero-badge]', 700]].forEach(function (p) {
      var el = h.querySelector(p[0]);
      if (el) setTimeout(function () { el.classList.add('is-in'); }, p[1]);
    });
  }
  document.querySelectorAll('[data-pcg-chat-trigger]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      var w = document.getElementById('printibly-chat-widget');
      if (w && w.shadowRoot) {
        var bu = w.shadowRoot.querySelector('.pb-bubble');
        if (bu) { e.preventDefault(); bu.click(); }
      }
    });
  });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-visible');
          io.unobserve(en.target);
          en.target.querySelectorAll('[data-stagger] > *').forEach(function (c, i) {
            c.style.transitionDelay = Math.round(20 * Math.sqrt(i) * 10) + 'ms';
            c.classList.add('is-visible');
          });
        }
      });
    }, { rootMargin: '0px 0px -5% 0px', threshold: 0.05 });
    document.querySelectorAll('[data-anim]').forEach(function (el) { io.observe(el); });
    var ci = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-revealed');
          ci.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -3% 0px', threshold: 0.05 });
    document.querySelectorAll('.pbrand-ingrid').forEach(function (el) { ci.observe(el); });
  }
})();
